import SessionView from './SessionView'

export default SessionView
